import axios from 'axios';
import RequestAbortManager from 'src/lib/utils/RequestAbortManager';
import { Observable } from 'windowed-observable';
import { ErrorCode } from '../../ErrorHandling/CustomErrorBoundary';
import { AuthCookie, getCookieValue } from '../../utils/cookieJar';
// We should not abort the following requests
const abortBlacklist = {
    authenticate: [],
    logout: [],
    '/token': [],
    'userMerchant/getInfoList': [],
    '/userMerchant/lastLogin': [],
    '/userMerchant/profile': [],
    '/userMerchant/businessInfo': [],
    '/userMerchant': ['PUT'],
    '/user/merchantInfoList': [],
};
// Create an instance of RequestAbortManager for managing request aborts
export const AbortManager = new RequestAbortManager(abortBlacklist);
const observable = new Observable('globalState');
// This instance will be used for configuring headers and custom config in future
const apiInstance = axios.create({
    baseURL: process.env.API_URL,
    headers: {
        Accept: 'application/json',
    },
    xsrfHeaderName: 'X-XSRF-TOKEN', // default
    xsrfCookieName: 'XSRF-TOKEN',
    withCredentials: true,
    // `undefined` (default) - set XSRF header only for the same origin requests
    withXSRFToken: true,
});
apiInstance.interceptors.request.use(AbortManager.requestInterceptor);
apiInstance.interceptors.response.use(AbortManager.responseSuccessInterceptor, AbortManager.responseErrorInterceptor);
// this api instance is used to fetch the auth token, added an interceptor to update headers when token becomes available
apiInstance.interceptors.request.use((config) => {
    // Add authorization header to every request
    const appToken = getCookieValue(AuthCookie.AUTH_TOKEN);
    if (appToken) {
        config.headers.Authorization = `Bearer ${appToken}`;
    }
    return config;
});
apiInstance.interceptors.response.use((response) => {
    return response;
}, (error) => {
    if (
    // TODO: create config to check for exception to handle error
    error?.response?.status === ErrorCode.UNAUTHORIZED &&
        // Work around to flash "Loading screen" on landing instead of unauthorized
        error?.config?.url?.toLowerCase() !== 'authenticate') {
        observable.publish({ ...observable.getEvents()[-1], globalError: error.response.status });
    }
    return Promise.reject(error);
});
export default apiInstance;
